export default __webpack_public_domain__ + __webpack_public_url__ + __webpack_public_path__ + "static/media/Icon-Module-not-purchased-mcolour.svg?v=a0cd92ac";